module.exports = __webpack_public_path__ + "static/media/EnvPromo-RedTree_02.d96b0150.jpg";